export default __webpack_public_path__ + "static/media/Wrist-straps of the Blood God (nm).a28e0301.jpg";